import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./CVAppPage.css";

export default function CVAppPage() {
  const { workspaceId } = useParams();
  const { user } = useAuth();

  // ASA-180 fase 3b: de cv-app deelt dezelfde httpOnly-sessiecookie (same-origin onder
  // /cv-app/) en hoeft het token niet meer via de URL (?vt=) te ontvangen.
  const cvAppUrl = useMemo(
    () => `/slimme-assistent/?workspaceId=${encodeURIComponent(workspaceId || "")}`,
    [workspaceId]
  );

  if (!user) {
    return (
      <div className="v-cv-page">
        <h1 className="v-page__title">CV Builder</h1>
        <p className="v-page__subtitle">Login required. Please sign in to Ventus again.</p>
      </div>
    );
  }

  return (
    <div className="v-cv-page">
      <div className="v-cv-page__header">
        <h1 className="v-page__title">CV Builder</h1>
        <p className="v-page__subtitle">Uses your active Ventus login session.</p>
      </div>
      <iframe title="Ventus CV App" src={cvAppUrl} className="v-cv-frame" />
    </div>
  );
}
